import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { logout, getUserDetails } from "../../../services/Auth/authService";

const TopMenu = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const userDetails = await getUserDetails();
        setUserInfo(userDetails);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, []);

  const handleAvatarClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    navigate("/auth/login");
  };

  const handleProfileClick = () => {
    navigate("/auth/profile");
    setDropdownOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <TopMenuContainer>
      {/*<LogoContainer>*/}
      {/*  <LogoImage src="/logo-dark-ziplink.png" alt="Zaplink Logo" />*/}
      {/*</LogoContainer>*/}

      <IconContainer>
        <AvatarContainer ref={dropdownRef} onClick={handleAvatarClick}>
          <Avatar />
          <DropdownMenu $isOpen={isDropdownOpen}>
            {userInfo ? (
              <UserInfoSection onClick={handleProfileClick}>
                <img src="/avatar.png" alt="User" className="avatar" />
                <UserInfo>
                  <UserName>
                    {userInfo.firstName} {userInfo.lastName}
                  </UserName>
                  <UserEmail>{userInfo.normalizedEmail}</UserEmail>
                </UserInfo>
              </UserInfoSection>
            ) : (
              <LoadingText>Loading...</LoadingText>
            )}
            <MenuDivider />
            <MenuOption onClick={handleProfileClick}>Settings</MenuOption>
            <MenuDivider />
            <LogoutButton onClick={handleLogout}>Sign Out</LogoutButton>
          </DropdownMenu>
        </AvatarContainer>
      </IconContainer>
    </TopMenuContainer>
  );
};

export default TopMenu;

// Updated Styled Components for TopMenu

const TopMenuContainer = styled.div`
  justify-content: space-between;
  background: #ffffff; /* Light background */
  color: #333; /* Darker text for contrast */
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

const AvatarContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`;

const Avatar = styled(FaUserCircle)`
  width: 40px;
  height: 40px;
  color: #252525; /* Dark avatar icon */
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 60px;
  right: 10px;
  background: #252525; /* Dark background for dropdown */
  border-radius: 8px;
  width: 300px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1001;
  pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  padding: 10px 0;
`;

const UserInfoSection = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  .avatar {
    border-radius: 50%;
    margin-right: 15px;
    width: 50px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.div`
  font-weight: bold;
  font-size: 1rem;
  color: #ffffff; /* White text for the dark dropdown */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const UserEmail = styled.div`
  font-size: 0.875rem;
  color: #b0b0b0; /* Lighter gray text for email */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MenuOption = styled.div`
  padding: 15px;
  font-size: 0.9rem;
  color: #ffffff; /* White text */
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #333333; /* Slightly darker hover */
  }
`;

const MenuDivider = styled.div`
  height: 1px;
  background-color: #444444; /* Darker divider line */
  margin: 5px 0;
`;

const LogoutButton = styled(MenuOption)`
  color: #e74c3c;
  font-weight: bold;
`;

const LoadingText = styled.p`
  padding: 15px;
  text-align: center;
  font-size: 0.9rem;
  color: #ffffff; /* White text for loading state */
`;
